const normalizeGroupName = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z]+/g, " ")
    .trim();

export const isAttackingTypesGroup = (value) =>
  /^(?:attack|attacking) types?$/.test(normalizeGroupName(value));

export const excludeAttackingTypesParameters = (parameters = []) =>
  (Array.isArray(parameters) ? parameters : []).filter(
    (parameter) => !isAttackingTypesGroup(parameter?.group?.name)
  );

export const excludeAttackingTypesParameterGroups = (parameterGroups = []) =>
  (Array.isArray(parameterGroups) ? parameterGroups : [])
    .filter((group) => !isAttackingTypesGroup(group?.[0]))
    .map(([groupName, parameters]) => [
      groupName,
      (Array.isArray(parameters) ? parameters : []).filter(
        (parameter) => !isAttackingTypesGroup(parameter?.group?.name)
      ),
    ])
    .filter(([, parameters]) => parameters.length > 0);
